import { DATA_HOOKS } from '../dataHooks';

export const getAgentToolbarHeight = () =>
  (document?.querySelector('.user-toolbar-expansion') as HTMLElement)
    ?.offsetHeight || 0;

export const getHeaderHeight = () =>
  (
    document?.querySelector(
      `div[data-hook="${DATA_HOOKS.HEADER}"]`
    ) as HTMLElement
  )?.offsetHeight || 0;

export const getTopOffsetForScrollToArticlePage = () =>
  getAgentToolbarHeight() + getHeaderHeight();
